import { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import { FaLocationDot } from "react-icons/fa6";
import useGoogleApis from '../../../Hooks/useGoogleApis';
import LoadingSpinner from '../LoadingSpinner';
import InputMask from 'react-input-mask';
import { useWarehouse } from '../../../Providers/WarehouseProvider';
import { validateZipCode } from '../../../Helpers/ValidatorHelper';

const ZipCodeInputModal = ({ show, onHide }) => {
    const { handleFetchPostalCode, postalCodeFromLocation } = useGoogleApis()
    const [zipCode, setZipCode] = useState(null)
    const [errorMessage, setErrorMessage] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const { handleGetAndSaveWarehouseByZpiCone } = useWarehouse()

    useEffect(() => {
        if (postalCodeFromLocation) {
            setZipCode(postalCodeFromLocation)
        }
    }, [postalCodeFromLocation])

    const handleZipCodeChange = (e) => {
        setErrorMessage(null)
        setZipCode(e.target.value)
    }

    const handleSaveClick = async () => {
        if (!zipCode || zipCode.trim() === '' || !validateZipCode(zipCode)) {
            setErrorMessage('Niepoprawny kod pocztowy!')
            return
        }

        if (await handleGetAndSaveWarehouseByZpiCone(zipCode) === false) {
            setErrorMessage('Nie udało się zlokalizować magazynu na podstawie kodu pocztowego!')
            return
        }
        onHide(zipCode)
    }
    const handleLocate = async () => {
        setIsLoading(true)
        const res = await handleFetchPostalCode()
        setIsLoading(false)
    }

    return (
        <Modal size='md' show={show} onHide={onHide} centered style={{ zIndex: 3000 }} enforceFocus={false}>
            <Modal.Header closeButton>
                <Modal.Title>Wprowadź kod pocztowy</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isLoading ? (<LoadingSpinner />) : (<>
                    <span className='ms-1 secondary-color-text'>Np: 60-123</span>
                    <div className="row">
                        <div className="col-11">
                            <InputMask
                                mask="99-999"
                                value={zipCode}
                                onChange={handleZipCodeChange}
                            >
                                {(inputProps) => (
                                    <Form.Control
                                        {...inputProps}
                                        placeholder="Kod pocztowy"
                                    />
                                )}
                            </InputMask>
                        </div>
                        <div className="col-1 element-pointer">
                            <FaLocationDot size={30} className='primary-accent-color-text' onClick={handleLocate} />
                        </div>
                    </div>
                    <div className={`d-flex justify-content-center mt-3 mb-3`}>
                        <span className='error-text-color'>{errorMessage}</span>
                    </div>
                    <div className="d-flex flex justify-content-end  mt-4">
                        <button className='btn-app-primary me-4' onClick={() => handleSaveClick()}>Zapisz</button>
                        <button className='btn-app-secondary' onClick={() => onHide(null)}>Anuluj</button>
                    </div>
                </>)}
            </Modal.Body>
        </Modal>
    )
}

export default ZipCodeInputModal